import type { Bid } from '../../types';

interface ItemsTabProps {readonly bid: Bid;}

export function ItemsTab({ bid }: ItemsTabProps) {
  const formatCurrency = (amount: number) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: bid.currency,
    }).format(amount);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-gray-900">Line Items ({bid.lines.length})</h3>
        <p className="text-sm text-gray-500">Total: {formatCurrency(bid.total)}</p>
      </div>
      <div className="overflow-hidden rounded-lg border">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                Item
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                SKU
              </th>
              <th className="px-4 py-3 text-right text-xs font-medium uppercase tracking-wider text-gray-500">
                Qty
              </th>
              <th className="px-4 py-3 text-right text-xs font-medium uppercase tracking-wider text-gray-500">
                Unit Price
              </th>
              <th className="px-4 py-3 text-right text-xs font-medium uppercase tracking-wider text-gray-500">
                Total
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {bid.lines.map((line) => (
              <tr key={line.lineId} className="hover:bg-gray-50">
                <td className="whitespace-nowrap px-4 py-3">
                  <p className="font-medium text-gray-900">{line.itemName}</p>
                </td>
                <td className="whitespace-nowrap px-4 py-3 text-sm text-gray-500">{line.sku}</td>
                <td className="whitespace-nowrap px-4 py-3 text-right text-sm">
                  {line.quantity} {line.unit}
                </td>
                <td className="whitespace-nowrap px-4 py-3 text-right text-sm text-gray-500">
                  {formatCurrency(line.unitPrice)}
                </td>
                <td className="whitespace-nowrap px-4 py-3 text-right text-sm font-medium">
                  {formatCurrency(line.totalPrice)}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot className="bg-gray-50">
            <tr>
              <td
                colSpan={4}
                className="px-4 py-3 text-right text-sm font-medium text-gray-900"
              >
                Subtotal
              </td>
              <td className="px-4 py-3 text-right text-sm font-medium">
                {formatCurrency(bid.subtotal)}
              </td>
            </tr>
            <tr>
              <td
                colSpan={4}
                className="px-4 py-3 text-right text-sm font-medium text-gray-900"
              >
                Tax
              </td>
              <td className="px-4 py-3 text-right text-sm font-medium">
                {formatCurrency(bid.tax)}
              </td>
            </tr>
            <tr>
              <td
                colSpan={4}
                className="px-4 py-3 text-right text-sm font-bold text-gray-900"
              >
                Total
              </td>
              <td className="px-4 py-3 text-right text-sm font-bold">
                {formatCurrency(bid.total)}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
